<template>

  <div id="chart" class = "donutchart">
    <h2> This is the chart title </h2>

  </div>

</template>

<script>



	import donutChart from '@/charts/donutchart.js';
	import * as d3 from 'd3'


	export default {
		name: "DonutChart",
		data: function () {
			return {
				dummydata: [
					[
						{
							"reassign_reason": "Contact unsucessful ",
							"cases": 273,
							"percent": 0.14
						},
						{
							"reassign_reason": "Equipment unavailable ",
							"cases": 140,
							"percent": 0.07200000000000001
						},
						{
							"reassign_reason": "Extended ETA ",
							"cases": 481,
							"percent": 0.24600000000000002
						},
						{
							"reassign_reason": "Facility closed/ Out of service ",
							"cases": 21,
							"percent": 0.011000000000000001
						},
						{
							"reassign_reason": "Force Spot ",
							"cases": 169,
							"percent": 0.086
						},
						{
							"reassign_reason": "Long tow - required respot ",
							"cases": 8,
							"percent": 0.004
						},
						{
							"reassign_reason": "Other",
							"cases": 668,
							"percent": 0.342
						},
						{
							"reassign_reason": "Shop/Driver declined call ",
							"cases": 195,
							"percent": 0.1
						}
					],
					[
						{
							"reassign_reason": "Contact unsucessful ",
							"cases": 2456,
							"percent": 0.07200000000000001
						},
						{
							"reassign_reason": "Equipment unavailable ",
							"cases": 1381,
							"percent": 0.040999999999999995
						},
						{
							"reassign_reason": "Extended ETA ",
							"cases": 3059,
							"percent": 0.09
						},
						{
							"reassign_reason": "Facility closed/ Out of service ",
							"cases": 210,
							"percent": 0.006
						},
						{
							"reassign_reason": "Force Spot ",
							"cases": 1815,
							"percent": 0.053
						},
						{
							"reassign_reason": "Long tow \u2013 required respot ",
							"cases": 143,
							"percent": 0.004
						},
						{
							"reassign_reason": "Other",
							"cases": 20190,
							"percent": 0.594
						},
						{
							"reassign_reason": "Shop/Driver declined call ",
							"cases": 4761,
							"percent": 0.14
						}
					]
				]

			}
		},
		methods: {
			chart: donutChart()
					.width(900)
					.height(400)
					.cornerRadius(3) // sets how rounded the corners are on each slice
					.padAngle(0.015) // effectively dictates the gap between slices
					.variable('percent')
					.category('reassign_reason')
		},
		mounted() {
			d3.select(this.$el)
					.datum(this.dummydata) // bind data to the div
					.call(this.chart);
		}
	}
</script>

<style>

  #chart {
    width: 85vw;
    margin: auto;
  }

  /* Make the percentage on the text labels bold*/
.donutchart .labelName tspan {
    font-style: normal;
    font-weight: 700;
}

.donutchart .labelName {
    font-size: 0.9em;
}


.toolCircle tspan.variable-highlight {
    font-size: 2em;
    font-family: sans-serif;
    fill: white;
    stroke-width: 2px;

}

.toolCircle tspan.incident-count {
    font-size: 1em;
    font-family: sans-serif;
    font-weight: bold;
}


  .donutchart polyline {
    opacity: .3;
    stroke: black;
    stroke-width: 2px;
    fill: none;
}


</style>
